import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=0c863cc0&scoped=true&"
import script from "./CommonHeader.vue?vue&type=script&lang=js&"
export * from "./CommonHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=0c863cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c863cc0",
  null
  
)

export default component.exports